<template>
  <div v-loading="fetchFeaturedStartupsInProgress">
    <StartupListTopNav />
    <ScrollTopButton />
    <ShortlistContext>
      <div
        v-for="group in featuredStartupsGroups"
        :key="group.id"
        class="mt-8 mb-8"
      >
        <p class="font-semibold text-lg text-gray-500 group">
          {{ group.name }}
        </p>
        <div v-if="false" class="bg-white rounded p-2">
          <div class="row">
            <StartupListTable :startups="group.startups" show-actions />
          </div>
        </div>
        <div v-for="startup in group.startups" :key="startup.id" class="my-4">
          <StartupHorizontalCard
            :startup="startup"
            @update="onStartupUpdate({ startup, data: $event })"
          />
        </div>
      </div>
    </ShortlistContext>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import useUser from 'states/useUser'
import useFeaturedStartupsFetch from './useFeaturedStartupsFetch'
import StartupHorizontalCard from 'components/startups/StartupHorizontalCard.vue'
import StartupListTable from '@/modules/startup-list/StartupListTable'
import StartupListTopNav from 'modules/startup-list/StartupListTopNav.vue'
import ShortlistContext from '@/contexts/ShortlistContext.vue'

export default {
  components: {
    StartupListTopNav,
    StartupListTable,
    StartupHorizontalCard,
    ShortlistContext,
  },
  setup(props) {
    const { user } = useUser()

    const {
      fetchFeaturedStartups,
      fetchFeaturedStartupsInProgress,
      featuredStartupsGroups,
    } = useFeaturedStartupsFetch({ orgId: user.value.organizationId })
    fetchFeaturedStartups()

    const onStartupUpdate = ({ startup, data }) => {
      Object.keys(data).forEach((key) => {
        startup[key] = data[key]
      })
    }

    return {
      featuredStartupsGroups,
      fetchFeaturedStartupsInProgress,
      onStartupUpdate,
    }
  },
}
</script>
